import { useProductSummaryName } from '../hooks/useProductSummaryName';

type ProductNameContainerProps = { children: React.ReactNode };

const ProductNameContainer = ({ children }: ProductNameContainerProps) => {
	const { blockClass, tag } = useProductSummaryName();

	const Tag = tag;

	return (
		<Tag
			className={`productNameContainer productNameContainer--${blockClass} nameWrapper nameWrapper--${blockClass} vtex-product-summary-2-x-productNameContainer vtex-product-summary-2-x-productNameContainer--${blockClass} mv0 vtex-product-summary-2-x-nameWrapper vtex-product-summary-2-x-nameWrapper--${blockClass} overflow-hidden c-on-base f5`}
		>
			{children}
		</Tag>
	);
};

export default ProductNameContainer;
